<template>
  <div style="margin: 20px 0 20px 0; padding:20px 20px 20px 20px; background-color: white">
    <el-form :inline="true">
      <el-form-item>
        <el-button type="danger" @click="dialogVisible=true">新增财务差额记录</el-button>
      </el-form-item>
    </el-form>
    <el-dialog title="新增财务差额记录" :visible.sync="dialogVisible" width="60%" @close="clearData" :close-on-click-modal="false">
      <el-form label-width="120px" :label-position="'right'">
        <el-form-item label="对冲产品">
          <el-select v-model="formData.hedgeProductType" placeholder="请选择对冲产品">
            <el-option v-for="item in hedgeProductTypeOptions" :key="item.key" :label="item.label" :value="item.key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="对冲目标类型">
          <el-select v-model="formData.hedgeTargetType" placeholder="请选择对冲产品">
            <el-option v-if="formData.hedgeProductType==='SPOT'" v-for="item in hedgeTargetTypeEnum_SPOT" :key="item.key" :label="item.label" :value="item.key"></el-option>
            <el-option v-if="formData.hedgeProductType==='SUPER_CONTRACT'" v-for="item in hedgeTargetTypeEnum_SUPER_CONTRACT" :key="item.key" :label="item.label" :value="item.key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="对冲目标值">
          <el-input v-model="formData.hedgeTargetValue" placeholder="请输入对冲目标值" required="required" clearable></el-input>
        </el-form-item>
        <el-form-item label="交易对">
          <el-autocomplete v-model="formData.pair" :fetch-suggestions="querySearchAsync" @change="findOne" required="required" clearable style="width: 250px"></el-autocomplete>
        </el-form-item>
<!--        <el-form-item label="交易对">-->
<!--          <el-input v-model="formData.pair" placeholder="请输入交易对" required="required" clearable></el-input>-->
<!--        </el-form-item>-->

        <el-form-item label="差额">
          <el-input v-model="formData.financeDifference" placeholder="请输入差额" type="number" required="required" step="0.01" clearable></el-input>
        </el-form-item>

        <el-form-item label="财务差额时间">
          <el-date-picker
              v-model="formData.startHedgeTime"
              type="datetime"
              placeholder="选择日期时间"
              align="right"
              :picker-options="pickerOptions">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="addHedgeFinanceDifference">立即创建</el-button>
          <el-button @click="dialogVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-form :inline="true">
      <el-form-item label="日期">
        <el-date-picker
            v-model="dateRange"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetimerange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions1">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="对冲产品:">
        <el-select v-model="hedgeProductType" placeholder="请选择对冲产品">
          <el-option v-for="item in hedgeProductTypeOptions" :key="item.key" :label="item.label" :value="item.key"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="对冲目标类型:">
        <el-select v-model="hedgeTargetType" placeholder="请选择对冲目标类型">
          <el-option v-if="hedgeProductType==='SPOT'" v-for="item in hedgeTargetTypeEnum_SPOT" :key="item.key" :label="item.label" :value="item.key"></el-option>
          <el-option v-if="hedgeProductType==='SUPER_CONTRACT'" v-for="item in hedgeTargetTypeEnum_SUPER_CONTRACT" :key="item.key" :label="item.label" :value="item.key"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="差额动作类型:">
        <el-select v-model="hedgeActionType" placeholder="请选择对冲产品">
          <el-option v-for="item in hedgeActionTypeEnum" :key="item.key" :label="item.label" :value="item.key"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="对冲目标值:">
        <el-input v-model="hedgeTargetValue" placeholder="请输入对冲目标值"></el-input>
      </el-form-item>
      <el-form-item label="交易对:">
        <el-input v-model="pair" placeholder="请输入交易对"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" :plain="true" @click="queryHedgeFinanceDifference">查询</el-button>
      </el-form-item>
    </el-form>

    <div class="top" v-if="isShow">
      <el-table :data="tableData" style="width: 100%" max-height="1000">

        <el-table-column prop="hedgeProductType" label="对冲产品类型" sortable></el-table-column>
        <el-table-column prop="hedgeTargetType" label="对冲目标类型" sortable></el-table-column>
        <el-table-column prop="hedgeTargetValue" label="对冲目标值" sortable></el-table-column>
        <el-table-column prop="hedgeActionType" label="对冲动作类型" sortable></el-table-column>
        <el-table-column prop="pair" label="交易对" sortable ></el-table-column>
        <el-table-column prop="startHedgeTime" label="财务差额时间" sortable></el-table-column>
        <el-table-column prop="financeDifference" label="财务差额" sortable ></el-table-column>
        <el-table-column prop="createdTime" label="创建时间" sortable ></el-table-column>
        <el-table-column prop="updateTime" label="更新时间" sortable ></el-table-column>

        <el-table-column prop="" label="操作" width="110">
          <template slot-scope="scope">
            <el-button @click="deleteData(scope.row)" type="primary" size="small">删除</el-button>
          </template>
        </el-table-column>

      </el-table>
      <el-pagination background
                     layout="total, sizes, prev, pager, next, jumper"
                     :page-size="pageSize"
                     :page-sizes="[1, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100]"
                     :total="total"
                     :current-page="currentPageNum"
                     @size-change="handleSizeChange"
                     @current-change="handleCurrentChange">
      </el-pagination>
      <div style="text-align:right">
        <el-button type="primary" plain @click="exportExcel()">当前页导出excel</el-button>
        <el-button type="primary" plain @click="exportAllExcel()">全量导出excel</el-button>
      </div>
    </div>

  </div>
</template>

<script>
import './store'
import '@/entries/Machine/cache'
import {mapActions, mapState} from "vuex";
import api from './hedgeApi'
import utils from "@/entries/HedgeCenter/MarketSheet/utils";

const externalOrderDirectionOptions = [{key:'BID', label:'买'}, {key:'ASK', label:'卖'}]
const hedgeActionTypeOptions = [{key:'', label:''}, {key:'MANUAL', label:'人工'}]
const hedgeTargetTypeEnum_SPOT_Op = [
  {key:'SPOT_PAIR_COMMON', label:'现货匹配交易对'},
  {key:'SPOT_PAIR_API', label:'现货只匹配交易对的API的部分，优先级SPOT'},
  {key:'SPOT_USER_ID', label:'用户ID'},
  // {key:'STRATEGY_NOT_EXISTS', label:'不存在的策略'},
]
const hedgeTargetTypeEnum_SUPER_CONTRACT_Op = [
  {key:'SC_PAIR', label:'超级合约的交易对'},
  {key:'SC_USER_ID', label:'超级合约的交易对用户ID'},
  {key:'SPOT_USER_ID', label:'用户ID'},
  // {key:'STRATEGY_NOT_EXISTS', label:'不存在的策略'},
]
const exchangeOptions = ["BINANCE","HUOBI","GATEIO","OKEX","FTX","COINEX","ZB","MXC","HBTC","INTERNAL"]
const pickerOptions1 = {
  shortcuts: [
    {
      text: '最近一天',
      onClick(picker) {const end = new Date();const start = new Date();start.setTime(start.getTime() - 3600*1000*24);picker.$emit('pick', [start, end]);}
    },
    {
      text: '最近三天',
      onClick(picker) {const end = new Date();const start = new Date();start.setTime(start.getTime() - 3600*1000*24*3);picker.$emit('pick', [start, end]);}
    },
    {
      text: '最近一周',
      onClick(picker) {const end = new Date();const start = new Date();start.setTime(start.getTime() - 3600*1000*24*7);picker.$emit('pick', [start, end]);}
    },
    {
      text: '最近一个月',
      onClick(picker) {const end = new Date();const start = new Date();start.setTime(start.getTime() - 3600*1000*24*30);picker.$emit('pick', [start, end]);}
    },
    {
      text: '最近两个月',
      onClick(picker) {const end = new Date();const start = new Date();start.setTime(start.getTime() - 3600*1000*24*60);picker.$emit('pick', [start, end]);}
    }
  ]
}

const columns = [
  {title:'ID',key:'id'},
  {title:'对冲产品类型',key:'hedgeProductType'},
  {title:'对冲目标类型',key:'hedgeTargetType'},
  {title:'对冲目标值',key:'hedgeTargetValue'},
  {title:'对冲动作类型',key:'hedgeActionType'},
  {title:'交易对',key:'pair'},
  {title:'财务差额时间',key:'startHedgeTime'},
  {title:'财务差额',key:'financeDifference'},
  {title:'创建时间',key:'createdTime'},
  {title:'更新时间',key:'updateTime'}
]

export default {
  name: "ReconciliationBalance",
  data() {
    return {
      dialogVisible: false,
      startTime:'',
      endTime:'',
      buffer:'',
      hedgeProductType:'',
      hedgeTargetType:'',
      hedgeActionType:'',
      hedgeTargetValue:'',
      pair:'',
      currentPageNum:1,
      pageSize:20,
      isShow:false,
      tableData:[],

      formData:{
        hedgeProductType:'',
        hedgeTargetType:'',
        hedgeTargetValue:'',
        pair:'',
        startHedgeTime:'',
        exchangeTime:'',
        financeDifference:''
      },

      dateRange:[],
      pickerOptions1:pickerOptions1,
      hedgeActionTypeEnum:hedgeActionTypeOptions,

      externalOrderDirectionEnum:externalOrderDirectionOptions,
      hedgeTargetTypeEnum_SPOT: hedgeTargetTypeEnum_SPOT_Op,
      hedgeTargetTypeEnum_SUPER_CONTRACT: hedgeTargetTypeEnum_SUPER_CONTRACT_Op,
    }
  },
  computed: {
    ...mapState('newHedgeStore', ['hedgeProductTypeOptions', 'pickerOptions']),
    ...mapState('quotationCache', ['configurations']),
    params() {
      return {
        startTime:new Date(this.dateRange[0]).getTime(),
        endTime:new Date(this.dateRange[1]).getTime(),
        hedgeProductType:this.hedgeProductType,
        hedgeTargetType:this.hedgeTargetType,
        hedgeTargetValue:this.hedgeTargetValue,
        pair:this.pair,
        pageNum:this.currentPageNum,
        pageSize: this.pageSize
      };
    },
    paramsBak() {
      return {
        startTime:new Date(this.dateRange[0]).getTime(),
        endTime:new Date(this.dateRange[1]).getTime(),
        hedgeProductType:this.hedgeProductType,
        hedgeTargetType:this.hedgeTargetType,
        hedgeTargetValue:this.hedgeTargetValue,
        pair:this.pair,
      };
    },
  },
  methods: {
    createStateFilter(queryString) {
      return (state) => {
        return (state.pair.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },

    deepCopy(source) {
      let sourceCopy = source instanceof Array ? [] : {};
      for (let item in source) {
        sourceCopy[item] = typeof source[item] === 'object' ? this.deepCopy(source[item]) : source[item];
      }
      return sourceCopy;
    },

    querySearchAsync(queryString, cb) {
      let restaurants = this.configurations;
      let results = queryString ? restaurants.filter(this.createStateFilter(queryString)) : restaurants;
      let suggest = [];
      for(let index in results) {
        suggest.push({'value':results[index].pair});
      }
      cb(suggest);
    },

    findOne() {
      let len = this.configurations.length;
      this.configuration = {};
      for (let i = 0; i < len; i++) {
        if (this.pair === this.configurations[i].pair) {
          this.configuration = this.deepCopy(this.configurations[i]);
          return;
        }
      }
    },

    addHedgeFinanceDifference(){
      this.formData.exchangeTime = new Date(this.formData.exchangeTime).getTime()
      this.formData.startHedgeTime = new Date(this.formData.startHedgeTime).getTime()
      api.addHedgeFinanceDifference(this.formData).then((response=>{
        if (response.data === true) {
          this.$message.success("添加财务差额记录成功")
          this.dialogVisible = false
        }
      }))
    },
    queryHedgeFinanceDifference(){
      if (this.dateRange.length !== 2 || String(this.dateRange[1]).split(",").length > 1){
        this.$message({showClose: true, message: '请选择日期', type: 'error'})
        return
      }

      if (this.buffer === ''){
        this.buffer = this.paramsBak
      } else {
        if (this.paramsBak !== this.buffer){
          this.params.pageNum = 1
          this.buffer = this.paramsBak
        }
      }

      api.queryHedgeFinanceDifference(this.params).then((response=>{
        this.isShow = true
        this.total = response.data.total
        this.pages = response.data.pages
        this.pageSize = response.data.size
        this.currentPageNum = response.data.current
        let tableData = response.data.records
        for (let key in tableData){
          tableData[key].updateTime = utils.getLocalTime(tableData[key].updateTime)
          tableData[key].createdTime = utils.getLocalTime(tableData[key].createdTime)
          tableData[key].startHedgeTime = utils.getLocalTime(tableData[key].startHedgeTime)
        }
        this.tableData = tableData
      }))
    },
    handleSizeChange(val){
      this.params.pageSize = val
      this.queryHedgeFinanceDifference()
    },
    handleCurrentChange(val) {
      this.params.pageNum = val
      this.queryHedgeFinanceDifference()
    },
    deleteData(data){
      api.deleteHedgeFinanceDifference(data).then((response)=>{
        if (response.data === true) {
          this.$message.success("删除成功")
          this.queryHedgeFinanceDifference()
        } else {
          this.$message.error("删除失败")
        }
      })
    },
    clearData() {
      this.formData = {
        hedgeProductType:'',
        hedgeTargetType:'',
        hedgeTargetValue:'',
        pair:'',
        startHedgeTime:'',
        exchangeTime:'',
        financeDifference:''
      }
    },

    exportExcel(){
      let startTime = utils.getLocalTime(this.dateRange[0])
      let endTime = utils.getLocalTime(this.dateRange[1])
      let title = '财务差额统计' + startTime + '-' + endTime
      utils.export2Excel(columns, this.tableData, title)
    },

    exportAllExcel(){
      api.queryAllHedgeFinanceDifference(this.params).then((response)=>{
        let records = response.data
        for (let key in records){
          records[key].startHedgeTime = utils.getLocalTime(records[key].startHedgeTime)
          records[key].updateTime = utils.getLocalTime(records[key].updateTime)
          records[key].createdTime = utils.getLocalTime(records[key].createdTime)
          records[key].exchangeTime = utils.getLocalTime(records[key].exchangeTime)
        }
        let startTime = utils.getLocalTime(this.dateRange[0])
        let endTime = utils.getLocalTime(this.dateRange[1])
        let title = '财务差额统计' + startTime + '-' + endTime
        utils.export2Excel(columns, records, title)
      })
    },
  },
  created() {
    this.hedgeProductType = this.hedgeProductTypeOptions[0].key;
    this.formData.hedgeProductType = this.hedgeProductTypeOptions[0].key;
  }
}
</script>

<style scoped>

</style>